import { render, staticRenderFns } from "./range-slider.vue?vue&type=template&id=44165d24&"
import script from "./range-slider.vue?vue&type=script&lang=js&"
export * from "./range-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/spee2/www/univers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44165d24')) {
      api.createRecord('44165d24', component.options)
    } else {
      api.reload('44165d24', component.options)
    }
    module.hot.accept("./range-slider.vue?vue&type=template&id=44165d24&", function () {
      api.rerender('44165d24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/range-slider/range-slider.vue"
export default component.exports